module.exports = __webpack_public_path__ + "static/media/event.14d7dc69.jpg";